import { forwardRef } from "react"

const Select = forwardRef(function Select({type, error, options, ...props}, ref) {
  let klass = "border sm:text-sm rounded-lg block w-full p-2.5"
  if (!error || error === "") {
    klass = klass + " bg-gray-50 border-gray-300 text-gray-900 focus:ring-primary-600 focus:border-primary-600"
  } else {
    klass = klass + " bg-red-50 border border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500"
  }

  return (
    <>
      <select
        ref={ref}
        className={klass}
        {...props}
        key={1}
      >
        {options.map((option) => (
          <option key={option.key} id={option.id} value={option.value}>{option.name}</option>
        ))}
      </select>
      {error !== "" && <p className={"mt-2 text-sm text-red-600"}>{error}</p>}
    </>
  )
})

export default Select;
